import React from 'react';
import noop from '../../utils/noop';
import * as styles from './body.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Body = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var children = _ref.children,
    _ref$onScroll = _ref.onScroll,
    onScroll = _ref$onScroll === void 0 ? noop : _ref$onScroll,
    enableScroll = _ref.enableScroll,
    _ref$hackOverlay = _ref.hackOverlay,
    hackOverlay = _ref$hackOverlay === void 0 ? false : _ref$hackOverlay,
    _ref$fitContent = _ref.fitContent,
    fitContent = _ref$fitContent === void 0 ? false : _ref$fitContent,
    _ref$allowOverflow = _ref.allowOverflow,
    allowOverflow = _ref$allowOverflow === void 0 ? false : _ref$allowOverflow;
  return ___EmotionJSX("div", {
    css: styles.body({
      hackOverlay,
      fitContent,
      allowOverflow
    })
  }, ___EmotionJSX("div", {
    ref: ref,
    css: styles.scrollContainer({
      enableScroll,
      fitContent
    }),
    onScroll: onScroll
  }, children));
});
export default Body;